import {Product} from "./product";

export class Query {
  public limit: number = 10;
  public offset: number = 0;
  public filters: any;
}

export class QueryState {
  constructor(public totalCount: number, public items: Product[], public limit: number, public offset: number) {
  }
}
